'use client';

import { useCallback, useEffect, useRef, useState } from 'react';
import { usePathname, useRouter } from 'next/navigation';
import { WINDOW_COLLAPSE_MS } from '@/lib/constants/window';

export function useCollapseNavigate() {
  const router = useRouter();
  const pathname = usePathname();
  const [collapsingKey, setCollapsingKey] = useState<string | null>(null);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const navigate = useCallback((href: string, key?: string) => {
    if (!href || href === pathname) return;

    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    setCollapsingKey(key ?? href);
    timerRef.current = setTimeout(() => {
      timerRef.current = null;
      router.push(href);
    }, WINDOW_COLLAPSE_MS);
  }, [pathname, router]);

  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);

  return { isCollapsing: collapsingKey !== null, collapsingKey, navigate };
}
